<template>
  <el-checkbox-button
    ref="checkbox"
    v-bind="$attrs"
    @click.native="handleClick"
  >
    <slot />
  </el-checkbox-button>
</template>

<script>
export default {
  name: 'RtCheckboxButton',
  methods: {
    handleClick () {
      this.$refs.checkbox.focus = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCheckboxButton.vue?49b2d124